import React from 'react';
import { handlePriceInput } from '../../utils/inputUtils';

/** Same cents-as-you-type behavior as Inventory > Products > Precio compra.
 * UI uses es-PE formatting; state/API receive plain decimal strings (e.g. 1250.00).
 */
export const formatAccountingMoney = (value, currency = 'PEN') => new Intl.NumberFormat('es-PE', {
    style: 'currency', currency, minimumFractionDigits: 2, maximumFractionDigits: 2,
}).format(Number(value) || 0);

const display = (value) => {
    if (value === '' || value == null) return '';
    const numeric = Number(value);
    return Number.isFinite(numeric) ? new Intl.NumberFormat('es-PE', {
        minimumFractionDigits: 2, maximumFractionDigits: 2,
    }).format(numeric) : '';
};

export default function AccountingMoneyInput({ value, onChange, ...props }) {
    const handleChange = (event) => {
        // Reuse the exact Inventory input handler, rather than interpreting a typed
        // amount as a full-sol value. 1 -> 0.01, 2500 -> 25.00.
        handlePriceInput(event);
        const formatted = event.target.value;
        const numeric = formatted === '' ? '' : formatted.replace(/,/g, '');
        onChange?.(numeric);
    };
    return <input {...props} type="text" inputMode="decimal" autoComplete="off"
        value={display(value)} onChange={handleChange} placeholder={props.placeholder || '0.00'} />;
}
